import createVueComponent from '../createVueComponent';

const CornerRightUp = createVueComponent('CornerRightUpIcon', [
  ['polyline', { points: '10 9 15 4 20 9', key: '1lr6px' }],
  ['path', { d: 'M4 20h7a4 4 0 0 0 4-4V4', key: '1plgdj' }],
]);

export default CornerRightUp;
